import { MessageItem } from './MessageItem';

export type CaseMessagesResponse = {
  messagesVmList: MessageItem[];
  isPaid: boolean;
  rowsLimit: number;
};

export const emptyCaseMessagesModel: CaseMessagesResponse = {
  messagesVmList: [],
  isPaid: false,
  rowsLimit: 0,
};
